import { randFloat } from "three/src/math/MathUtils.js";
import MainExperience from "../MainExperience/MainExperience";
import {
  SphereGeometry,
  MeshBasicMaterial,
  Mesh,
  Points,
  BufferGeometry,
  BufferAttribute,
  PointsMaterial,
  Color,
} from "three";
import { getDeviceScreen } from "../../utils/utils";

export default class NightSky {
  constructor() {
    this.experience = new MainExperience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;

    this.screenSize = getDeviceScreen(window.innerWidth);
    this.createStars();
    this.createMoon();
  }

  createStars() {
    this.starGeometry = new BufferGeometry();

    const vertices = [];
    const starNumber = 1000;

    const range = 1000;

    for (let i = 0; i < starNumber; i++) {
      const point = [
        randFloat(-range, range),
        randFloat(20, 100),
        randFloat(-range, range),
      ];
      vertices.push(...point);
    }

    this.starGeometry.setAttribute(
      "position",
      new BufferAttribute(new Float32Array(vertices), 3)
    );

    const starMaterial = new PointsMaterial({
      color: 0xffffff,
      size: 0.25,
      transparent: true,
      map: this.resources.items.starParticle,
    });

    const mesh = new Points(this.starGeometry, starMaterial);

    mesh.renderOrder = -1;
    this.scene.background = new Color(0x01002e);
    this.scene.add(mesh);
  }

  createMoon() {
    this.moonGeometry = new SphereGeometry(15, 32, 32);
    this.moonMaterial = new MeshBasicMaterial({
      map: this.resources.items.moon,
      color: new Color(0xffffff),
    });

    this.moon = new Mesh(this.moonGeometry, this.moonMaterial);

    if (getDeviceScreen(window.innerWidth) === "desktop") {
      this.moon.position.set(-200, 30, -100);
    } else if (getDeviceScreen(window.innerWidth) === "tablet") {
      this.moon.position.set(-100, 30, -100);
    } else if (getDeviceScreen(window.innerWidth) === "mobile") {
      this.moon.position.set(-100, 50, -200);
    } else {
      this.moon.position.set(-80, 50, -200);
    }
    this.scene.add(this.moon);
  }
}
